import React from 'react';
import './PageLoader.css';
const PageLoader: React.FC = () => {
  return <div className="page-loader-overlay" data-id="element-63">
      <div className="loader" data-id="element-64">
        <div className="square" id="sq1" data-id="element-65"></div>
        <div className="square" id="sq2" data-id="element-66"></div>
        <div className="square" id="sq3" data-id="element-67"></div>
        <div className="square" id="sq4" data-id="element-68"></div>
        <div className="square" id="sq5" data-id="element-69"></div>
        <div className="square" id="sq6" data-id="element-70"></div>
        <div className="square" id="sq7" data-id="element-71"></div>
        <div className="square" id="sq8" data-id="element-72"></div>
        <div className="square" id="sq9" data-id="element-73"></div>
      </div>
    </div>;
};
export default PageLoader;